const ErrorService = {
    errorConsole(errorObject) {
        console.log("errorObject",errorObject.response)
    }
}
export default ErrorService;